import { API_BASE_URL } from '../config';
import { authHeader,readApiJson } from './auth';
import {isPaperAccount,paperMultipleRequest} from './paper';
export async function multipleRequest(path:string,body?:unknown,signal?:AbortSignal){
  if(isPaperAccount())return paperMultipleRequest(path,body,signal);
  const authorization=authHeader();
  const r=await fetch(API_BASE_URL+'/api/multiples'+path,{method:body?'POST':'GET',signal,
    headers:{...authorization,'Content-Type':'application/json'},...(body?{body:JSON.stringify(body)}:{})});
  return readApiJson(r,authorization.Authorization);
}
export const multiMoney=(cents:number)=>new Intl.NumberFormat('en-AU',{style:'currency',currency:'AUD'}).format(cents/100);
export const multiTime=(v:string)=>new Date(v).toLocaleString('en-AU',{timeZone:'Australia/Sydney',month:'short',day:'numeric',hour:'2-digit',minute:'2-digit'});
